// Sync filter/pagination state with the URL query string so filters survive
// a page refresh or a shared link. `schema` maps a field name to how it
// should be parsed back from the URL: 'number' | 'date' | 'pageSize' (numeric
// or the literal 'ВСЕ') | 'string' (default).
export function parseFiltersFromSearch(search, schema) {
    const params = new URLSearchParams(search);
    const result = {};
    Object.keys(schema).forEach(key => {
        if (!params.has(key)) return;
        const raw = params.get(key);
        if (raw === '') return;
        const type = schema[key];
        if (type === 'number') {
            const num = Number(raw);
            if (!Number.isNaN(num)) result[key] = num;
        } else if (type === 'date') {
            const date = new Date(raw);
            if (!isNaN(date.getTime())) result[key] = date;
        } else if (type === 'pageSize') {
            result[key] = raw === 'ВСЕ' ? raw : (Number(raw) || undefined);
        } else {
            result[key] = raw;
        }
    });
    return result;
}

export function filtersToSearch(values) {
    const params = new URLSearchParams();
    Object.keys(values).forEach(key => {
        const value = values[key];
        if (value === null || value === undefined || value === '') return;
        if (value instanceof Date) {
            if (isNaN(value.getTime())) return;
            params.set(key, value.toISOString());
        } else {
            params.set(key, value);
        }
    });
    return params.toString();
}

// Replaces the current URL's query string (no new history entry) with the
// serialized filter values.
export function syncFiltersToUrl(history, values) {
    const search = filtersToSearch(values);
    history.replace({search: search ? `?${search}` : ''});
}
